<template>
  <div class="detail">
    <video-player
      :baseUrl="baseUrl"
      :videoUrl="videoUrl"
      :title="title"
      :setNum="setNum"
      :num="num"
      :videoFormat="videoFormat"
    ></video-player>

    <div class="content" style="clear: both; height: 700px">
      <evaluate-box></evaluate-box>
      
      <ranking-box :rankingList="rankingList"></ranking-box>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "./VideoPlayer.vue";
import EvaluateBox from "./EvaluateBox.vue";
import RankingBox from "./RankingBox.vue";
import videos from "../ossVideo2";

export default {
  name: "Detail8",
  components: { VideoPlayer, EvaluateBox, RankingBox },
  data() {
    return {
      baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video10/",
      videoUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/video10/1.mp4",
      title: "熊猫博士看世界：新冠肺炎全科普",
      setNum: 4,
      videoFormat: 'mp4',
      num: "1",
      rankingList: videos.puzzleRankingList
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  padding: 110px 100px 20px;
  .content {
    position: relative;
  }
}
</style>


